import { WalkAndPunchApiClient } from 'src/proxy/api/walkandpunch-api.proxy';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export enum TemplateSourceEnum {
  Punches = 1,
}

@Injectable()
export class PunchesTemplatesStoreService {
  _punchesTemplates$ = new BehaviorSubject<any[]>(null);

  constructor(private customTemplateService: WalkAndPunchApiClient) {}

  loadPunchesTemplates() {
    return this.customTemplateService.v1CustomTemplateGetByProjectTemplateAndSourceGET(TemplateSourceEnum.Punches);
  }

  refreshPunchesTemplates() {
    this.loadPunchesTemplates().subscribe((data) => {
      this.punchesTemplates = data;
    });
  }

  get punchesTemplates() {
    return this._punchesTemplates$.value;
  }

  set punchesTemplates(data: any[]) {
    this._punchesTemplates$.next(data);
  }

  get punchesTemplates$() {
    return this._punchesTemplates$;
  }
}
